// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3Kc3y","alertIcon":"ConfirmModal_alertIcon__18g0i"};